import Navbar from "../Components/Navbar";
import ContactFooter from "../Components/ContactFooter";

export function Homescreen() 
{
    return (
        <>
            <Navbar />
          
            <div className="homepage-grid">
              <div className="picture-container homepage-grid--main-image" style={{ backgroundImage: `url(${require('../Images/piaggio-cutout.png')})` }} />

              <div className="homepage-grid--sub-images">
                <div className="picture-container" style={{ backgroundImage: `url(${require('../Images/bitterkoekjes.jpeg')})` }}/>
                <div className="picture-container" style={{ backgroundImage: `url(${require('../Images/eclair.jpeg')})` }}/>
                <div className="picture-container" style={{ backgroundImage: `url(${require('../Images/fruit-slof.jpeg')})` }}/>
                <div className="picture-container" style={{ backgroundImage: `url(${require('../Images/millionairs-shortbread.jpeg')})` }}/>
                <div className="picture-container" style={{ backgroundImage: `url(${require('../Images/pistache-choc-chip.jpeg')})` }}/>
              </div>

              <div className="white-text-block">
                <h1 className="header-1">
                  Welkom bij Smaeck.
                </h1>
                <p>
                  Na 3,5 jaar een gezellige winkel te hebben gehad op het Vlietplein was het tijd voor iets nieuws. 
                  En omdat bij Smaeck alles draait om passie en liefde voor het bakken ga ik daar natuurlijk lekker mee door. 
                  Nu kruis ik met mijn blauwe Piaggio Ridderkerk en omstreken door, om de heerlijkste zelfgemaakte gebakjes 
                  en koeken bij jouw thuis te bezorgen!<br></br><br></br>

                  Bestellingen kunnen online geplaatst worden tot woensdagavond 22.00 op basis van de bestellijst 
                  die iedere zondagochtend online komt. Elke vrijdagmiddag/avond wordt het verse gebak bij je bezorgd 
                  of je haalt het 's ochtends op in het centrum.
                  Heb je grotere bestellingen of bijzondere wensen? Aarzel niet om contact op te nemen!<br></br><br></br>

                  Daarnaast vind je de Piaggio ook iedere vrijdag in het centrum van Ridderkerk, met een vast assortiment 
                  aan lekkers en een aantal wekelijkse specials!<br></br><br></br>

                  Je kunt de Piaggio van Smaeck ook inhuren voor bruiloften of feesten inhuren met gebak naar keuze! 
                  Bel of mail voor de voorwaarden.<br></br><br></br>

                  Hopelijk tot snel!
                </p>
              </div>
            </div>
            
            <ContactFooter />
        </>
    );
}

export default Homescreen;